import React, { Component, useState } from 'react';
import TableRow from './TableRow';
import { Result } from '../../types/Result';
import { IColInfo, ITableBodyProps } from './Interfaces';
import { useTranslations } from '../../contexts/translationContext';
import { useEffect } from 'react';
import Spinner from '../Spinner/Spinner';

const TableBody: React.FC<ITableBodyProps> = ({ colInfos, colUserSettings, tableData, refreshNr, serverErrors, onNavigate, onRowClick, onCellChange, onSelectedRowsChange }) => {
    const [noData, setNoData] = useState<string>('No data available');
    const [loadingData, setLoadingData] = useState<string>('Loading data...');
    const { translate } = useTranslations();

    useEffect(() => {
        translate('No data available', 'DataTable', 'No data available').then(translated => setNoData(translated));
        translate('Loading data', 'DataTable', 'Loading data').then(translated => setLoadingData(translated));
    }, []);

    let keyInfo: IColInfo;

    colInfos.forEach(function (colInfo) {
        if (colInfo.key) {
            keyInfo = colInfo;
        }
    });

    if (!tableData)
        return (<tbody className="plm-datatable-tbody"><tr><td colSpan={colUserSettings.filter(x => x.visible !== false).length} className={'text-center'}>{loadingData}<Spinner /></td></tr></tbody>);

    if (tableData.length === 0)
        return (<tbody className="plm-datatable-tbody"><tr><td colSpan={colUserSettings.filter(x => x.visible !== false).length} className={'text-center'}>{noData}</td></tr></tbody>);

    if (tableData) {
        tableData.forEach((data) => { data = { ...data, _isRowActive: false } })
    }

    function rowClick(rowData: any) {
        if (tableData)
            tableData.forEach((row) => { row['_isRowActive'] = false })

        rowData['_isRowActive'] = true;

        if (onRowClick)
            onRowClick(rowData);
        else
            onNavigate(getKey(rowData));
    }

    function getKey(rowData: any) {
        let key: any;
        if (keyInfo && keyInfo.dataProp) {
            keyInfo.dataProp.split('.').reduce((object, propertyName, index, elements) => {
                if (index === elements.length - 1) {
                    key = object[propertyName];
                }
                if (object && object[propertyName]) {
                    return object[propertyName];
                }
                return null;
            }, rowData);
        }
        return key;
    }

    let tableRows = tableData.map(function (rowData, rowIndex) {
        let errors: Result | undefined = undefined
        if (serverErrors) {
            errors = serverErrors[rowIndex];
        }

        return (<TableRow key={refreshNr + '-' + rowIndex} rowData={rowData} rowIndex={rowIndex} refreshNr={refreshNr} colInfos={colInfos} colUserSettings={colUserSettings} onRowClick={rowClick} onCellChange={onCellChange} serverErrors={errors} onSelectedRowsChange={onSelectedRowsChange} />);
    });

    return (<tbody className="plm-datatable-tbody">{tableRows}</tbody>);
}
export default TableBody;